import { INameId } from '@modeso/types__aumico-lib-core-be';

export interface IFliFormDialogResult {
    fliName?: string;
    fliCaption: string;
    fliCashFlowType: INameId;
    fliType: INameId;
    parentGroup: INameId;
    isUncoveredShortfallFli?: boolean;
}
